import { render } from "./FeedbackWidget.vue?vue&type=template&id=107e9d2d&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js"

import "./FeedbackWidget.vue?vue&type=style&index=0&id=107e9d2d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107e9d2d"]])

export default __exports__